// @flow

import React from 'react';
import classnames from 'classnames';
import Icon from '../Icon';
import styles from './styles.module.scss';
import { P } from '../Typography';

type CheckboxProps = {
  name: string,
  error?: string,
  checked: boolean,
  label?: string,
  className?: string,
  onChange: (e: SyntheticInputEvent<HTMLInputElement>) => void,
  disabled?: boolean,
};

const Checkbox = ({
  label,
  name,
  checked,
  onChange,
  className = '',
  error = '',
  disabled = false,
}: CheckboxProps) => (
  <>
    <div
      className={classnames(styles.checkbox, className, {
        [styles.disabled]: disabled,
      })}
    >
      <label htmlFor={name}>
        <input
          disabled={disabled}
          id={name}
          onChange={onChange}
          type="checkbox"
          checked={checked}
        />
        <span className={classnames(styles.checkbox__icon, { [styles.checked]: !!checked })}>
          {checked && <Icon icon="check" />}
        </span>
        {label && label.length > 0 && <b>{label}</b>}
      </label>
    </div>
    {error && <P use="error">{error}</P>}
  </>
);

Checkbox.defaultProps = {
  label: '',
};

export default Checkbox;
